export { default, isStaticPath } from './link'
